/**
 * The RepletoryReach mark: a speech bubble with three dots.
 *
 * Traced from `_UI_improvements/tenant/images/logo.png` (1254px, stroke 84,
 * stadium body, tail on the lower left), so the inline mark, the favicon and
 * the app icons are the same drawing at different sizes.
 *
 * It draws in `currentColor`, so the colour is set by whatever contains it:
 * `--rr-color-primary` on the light chrome, and the same teal on the dark
 * sidebar, where it reads cleanly without a container tile. The reference
 * shell puts the mark bare next to the wordmark, not inside a rounded square.
 *
 * `aria-hidden` because the wordmark beside it already names the product; a
 * lone mark that acts as a link gets its label from the link.
 */
export function BrandLogo(
  { size = 28, className, style }: { size?: number; className?: string; style?: React.CSSProperties }
) {
  return (
    <svg
      className={className}
      style={style}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      focusable="false"
    >
      <rect x="3.2" y="4.35" width="17.6" height="12.15" rx="6.08" />
      <path d="M6.1 16.5V19.3L10.2 16.5" />
      <circle cx="7.85" cy="10.85" r="1.35" fill="currentColor" stroke="none" />
      <circle cx="12" cy="10.85" r="1.35" fill="currentColor" stroke="none" />
      <circle cx="16.15" cy="10.85" r="1.35" fill="currentColor" stroke="none" />
    </svg>
  );
}
